// extracted by mini-css-extract-plugin
var _1 = "Modal_body__15857";
var _2 = "Modal_bodyScroll__5961d";
var _3 = "Modal_bordered__7ba26";
var _4 = "Modal_center__f8869";
var _5 = "Modal_close__265b0";
var _6 = "Modal_containerWrap__75f9d";
var _7 = "Modal_crop__fa9d1";
var _8 = "Modal_description__674fc";
var _9 = "Modal_dialog__fd4d9";
var _a = "Modal_end__2c713";
var _b = "Modal_footer__b4faa";
var _c = "Modal_fullScreen__bb722";
var _d = "Modal_gapLarge__5caf9";
var _e = "Modal_gapMedium__bdce2";
var _f = "Modal_gapMini__10631";
var _10 = "Modal_header__aa98e";
var _11 = "Modal_overlay__ed365";
var _12 = "Modal_portalRoot__538f7";
var _13 = "Modal_root__0ab7e";
var _14 = "Modal_start__0d07e";
var _15 = "Modal_tabs__603b5";
var _16 = "Modal_title__2429f";
export { _1 as "body", _2 as "bodyScroll", _3 as "bordered", _4 as "center", _5 as "close", _6 as "containerWrap", _7 as "crop", _8 as "description", _9 as "dialog", _a as "end", _b as "footer", _c as "fullScreen", _d as "gapLarge", _e as "gapMedium", _f as "gapMini", _10 as "header", _11 as "overlay", _12 as "portalRoot", _13 as "root", _14 as "start", _15 as "tabs", _16 as "title" }
